import { CardContainer } from '../../components/CardContainer/CardConteiner'
import MentorCard from '../../components/Cards/MentorCard'
import { MentorCardPlaceholder } from '../../components/Cards/MentorCardPlaceholder'
import TitleCard from '../../components/Cards/TitleCard'
import { VideoIcon } from '../../components/Icons'
import { useMentorsState } from '../../hooks/storeHooks/useMentors'
import { useScrollToTop } from '../../hooks/useScrollToTop'
import type { Title } from './useMentorsSearch'
import { useMentorsSearch } from './useMentorsSearch'

function SearchPage() {
  useScrollToTop()

  const { favoriteMentors } = useMentorsState()

  const { titles, mentors, isSearchQuestion, isLoading, query } =
    useMentorsSearch()

  if (isLoading) {
    return null
  }

  return (
    <div className="tc-mv-main-container pb-16">
      {isSearchQuestion && (
        <CardContainer
          title={
            <>
              <div className="text-white flex items-center text-xl">
                <span className="me-2">
                  <VideoIcon size={20} />
                </span>
                Watch
              </div>
              <p className="text-white mb-2 text-sm">
                Interactive videos you can pause and question.
              </p>
            </>
          }
          containerClassName="!pb-0 mb-8"
          disableScrollToTop
        >
          {titles.map((title: Title, i) => (
            <TitleCard key={i} {...title} />
          ))}
        </CardContainer>
      )}

      <CardContainer
        title={
          <>
            <div className="text-white flex items-center text-xl">
              <i className="fa-solid fa-star text-base me-2" />
              Companions
            </div>
            {!!mentors && (
              <p className="text-white mb-2 text-sm">
                {mentors?.length
                  ? 'On-demand AI experts. Ask anything.'
                  : `No companions found for "${query}”. Try a different query.`}
              </p>
            )}
          </>
        }
      >
        {mentors?.map(mentor => {
          return mentor.status === 'Completed' || !isSearchQuestion ? (
            <MentorCard
              key={mentor.mentorId}
              profile={mentor}
              renderCount={0}
              isAuthenticated={true}
              isFavorite={favoriteMentors.includes(mentor.mentorId)}
              location={`${window.location.pathname}${window.location.search}`}
            />
          ) : (
            <MentorCardPlaceholder key={mentor.mentorId} />
          )
        })}
      </CardContainer>
    </div>
  )
}

export default SearchPage
